import React, { FunctionComponent } from 'react';
import { SvgIcon } from '@material-ui/core';

const HelmetIcon: FunctionComponent = () => {
  return (
    <SvgIcon
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: '20px', width: '20px', fill: 'currentColor' }}
    >
      <path d="M27.83,8.45C27.66,8.18,23.45,2,16,2c-3.58,0-6.53,1.14-8.76,3.39C3.47,9.21,2.97,14.94,3,18c0,3.09,0.99,7.07,1.03,7.24 l0.07,0.27l4.73,4.73L28,19.59V8.7L27.83,8.45z M5,17.99c-0.01-1.13,0.06-2.66,0.36-4.3l9.83-2.46l0.35,2.11 c0.21,1.27-0.41,2.53-1.54,3.13l-8.73,4.7C5.12,20.13,5,19,5,17.99z M26,18.41L9.17,27.76l-3.27-3.27c-0.06-0.26-0.16-0.7-0.27-1.24 l9.31-5.02c1.88-1.01,2.91-3.11,2.56-5.22l-0.71-4.25L5.92,11.49C6.47,9.81,7.33,8.15,8.67,6.8C10.5,4.94,12.97,4,16,4 c5.61,0,9.2,4.27,10,5.33V18.41z" />
    </SvgIcon>
  );
};

export default HelmetIcon;
